import { render, staticRenderFns } from "./ProfileDetailItem.vue?vue&type=template&id=57c4f1cf&scoped=true"
import script from "./ProfileDetailItem.vue?vue&type=script&lang=js"
export * from "./ProfileDetailItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetailItem.vue?vue&type=style&index=0&id=57c4f1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4f1cf",
  null
  
)

export default component.exports